module.exports = __webpack_public_path__ + "img/angst-en-paniek.png";